import { type FunctionComponent } from 'react';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

const HummError: FunctionComponent = () => (
  <PleaseWaitOverlay
    icon="warning"
    iconStoke="red-200"
    title="We've encountered an error checking your credit application state with our lender, Humm."
    labelLine1="Please refresh the page to try again, or contact Ideal4Finance if this has occurred more than once"
  />
);

export default HummError;
